module.exports = __webpack_public_path__ + "images/emoji/jeans.2aa99d030a4f914cafac.png";